import * as Recoil from "recoil";
import { userIdState } from "atoms/atoms-admin";

export const useUser = () => {
  const userId = Recoil.useRecoilValue(userIdState); // current userId

  return { userId };
};
